import type { ScanStatus } from '@/api/client'

/**
 * Labels and badge styling for the one status model.
 *
 * The backend maps every raw scan status (completed, skipped_cached,
 * skipped_locked, …) onto these five before the list ever sees it, so this is
 * presentation only — no second mapping table on the frontend.
 */

export const STATUS_LABEL: Record<ScanStatus, string> = {
  pending: 'In wachtrij',
  running: 'Bezig',
  success: 'Geslaagd',
  failed: 'Mislukt',
  skipped: 'Overgeslagen',
}

export const STATUS_VARIANT: Record<ScanStatus, 'success' | 'destructive' | 'secondary' | 'outline'> = {
  pending: 'outline',
  running: 'secondary',
  success: 'success',
  failed: 'destructive',
  skipped: 'outline',
}

export const KIND_LABEL: Record<'seo' | 'security', string> = {
  seo: 'SEO',
  security: 'Security',
}

const SCAN_TYPE_LABEL: Record<string, string> = {
  onpage: 'On-page',
  site_crawl: 'Site crawl',
  tech_audit: 'Technisch',
  zap_baseline: 'ZAP baseline',
  zap_full: 'ZAP full',
  nuclei: 'Nuclei',
}

export function scanTypeLabel(scanType: string): string {
  return SCAN_TYPE_LABEL[scanType] ?? scanType
}

export function formatDuration(seconds: number | null): string {
  if (seconds === null) return '—'
  if (seconds < 60) return `${seconds.toFixed(1)}s`
  const mins = Math.floor(seconds / 60)
  const rest = Math.round(seconds % 60)
  return `${mins}m ${rest}s`
}
